import { IconWarning } from '@/components/icons'
import { cn } from '@/lib/classMerge'
import { FieldErrors } from 'react-hook-form'

interface IFormErrorProps {
  text?: string | FieldErrors<FormData>
  className?: string
  wrapperClassName?: string
}

export default function FormError({
  text,
  className,
  wrapperClassName
}: IFormErrorProps) {
  return (
    <div className={cn('flex items-center gap-1.5', wrapperClassName)}>
      <IconWarning />
      <p
        className={cn('text-xs font-semibold text-red-500', className)}
      >{`${text}`}</p>
    </div>
  )
}
